type IFeatureFlags = {
  notifications: boolean;
  manualMetadata: boolean;
};

export const featureFlags: IFeatureFlags = {
  notifications: false,
  manualMetadata: true,
};
